module.exports = __webpack_public_path__ + "static/media/3DPPA3.3f48370c.jpg";